export const en = {
    'empty-price': 'None',
    from: 'from',
    to: 'to'
};
